module.exports = __webpack_public_path__ + "static/media/quora.0ecedb17.svg";